import axios from "axios";
import { useState } from "react";
import toast from "react-hot-toast";
import { useNavigate } from "react-router-dom";

function DeactivateAccount({ isOpen, onClose, onSave }) {

  const [reason, setReason] = useState("");
  const navigate = useNavigate();
  if (!isOpen) return null; // Don't render if modal is closed

   

// Function definiton for Deactivate account
  const handleSave = async () => {
    if (!reason) {
      toast.error("Please select a reason before deactivating.");
      return;
    }

    try {
      const token = localStorage.getItem("authToken");
      const response = await toast.promise( axios.post(`${process.env.REACT_APP_API_BASE}/user/deactivateAccount`, {
        reason,
      },
       {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    ),
     {
          loading: "Deactivating Account...",
          success: "Account Deactivate successfully",
          error: "Failed to Deactivate Account ❌",
        }
      );

      localStorage.removeItem("AuthToken");
        localStorage.removeItem("user");
        localStorage.removeItem("expiry");
          localStorage.removeItem("hostData");
          localStorage.removeItem("userWishlist");
           localStorage.removeItem("selectedCurrency");
        navigate("/");
      onClose(); // close modal after success
    } catch (error) {
      console.error("❌ Error deactivating account:", error);
      // alert("Something went wrong. Please try again.");
    }
  };


  return (
    <div
      className="modal fade all_sm_modalss show sm_size_arreea"
      style={{
        display: "block",
        backgroundColor: "rgba(0, 0, 0, 0.6)",
        zIndex: 1050,
      }}
    >
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content">
          <div className="modal-header">
            <div className="titlss">
              <h5 className="modal-title">
                What prompted you to deactivate?
              </h5>
            </div>
            <button
              type="button"
              className="btn-close"
              onClick={onClose}
            >
              <i className="fa fa-times"></i>
            </button>
          </div>

            <div className="choose_liststs">
			 <ul>

        {[
                "I have safety or privacy concerns.",
                "I’m not getting value from the service.",
                "I’m taking a break.",
                "I get too many notifications.",
                "Other reasons.",
              ].map((text, i) => (
                <li className="bothsredoibtn" key={i}>
                  <label className="label--radio rft">
                    <span className="diss">{text}</span>
                    <input
                      className="radio"
                      type="radio"
                      value={text}
                      name="privacy"
                      checked={reason === text}
                      onChange={(e) => setReason(e.target.value)}
                    />
                  </label>
                </li>
              ))}
			  
			 </ul>
			</div>

          <div className="ftr_bottomss">
		    <button type="button" className="al_suports_btns" onClick={onClose}>
              Cancel
            </button>
		  
            <button type="button" className="al_suports_btns act" onClick={handleSave}>
              Deactivate
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default DeactivateAccount;
